import React from 'react';

function DefaultEditor({ pageContent, setPageContent, pageName }) {
  return (
    <div className="page-editor">
      <div className="editor-card">
        <h3>📄 {pageName} Editor</h3>
        <div className="form-group">
          <label>Page Title</label>
          <input value={pageContent.title || ''} onChange={(e) => setPageContent({...pageContent, title: e.target.value})} className="form-input" />
        </div>
        <div className="form-group">
          <label>Page Content (HTML)</label>
          <textarea value={pageContent.content || ''} onChange={(e) => setPageContent({...pageContent, content: e.target.value})} rows="15" className="form-input" placeholder="Write your page content here. You can use HTML tags." />
        </div>
      </div>
    </div>
  );
}

export default DefaultEditor;